var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',[_c('payment',{staticClass:"tab-pane col-12 col-xl-9 px-0 show active",attrs:{"slot":"tabContent","cartMembers":_vm.cartMembers,"type":'membership',"id":"payment","role":"tabpanel","aria-label":"Payment"},slot:"tabContent"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb0c65c6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/MyMembership/MyMembershipPayment.vue
// module id = 834
// module chunks = 30